<ng-template #content let-modal>  
  <div class="modal-body" style="padding: 0%;">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()" style="height: 55px;"> <span
        aria-hidden="true" style="padding: 0px 13px 13px 13px;
        font-size: 31px;
        color: black !important;
        font-weight: 400;"> &times; </span> </button>
    <p class="text-left px-3" id="saveFileText" style="color: green"> {{ saveFileText }} </p> <img class="img-fluid main-img"
      src="/../../assets/images/share/bg.svg" style=" width:750px;
     height: 311px;
    " />
    <div style="align-items: center; text-align: center"> <span class="upload-title mt-2"
        style="font-weight: 500; font-size: 24px;">Share Your File With Friend</span>
      <span class="d-block mt-1 mb-2" style="font-size: 16px;font-weight: 500;">Choose your Social Media
        Platform</span>
    </div>
    <div class="row justify-content-center share_modal_social">
      <div class="col-md-1 col-1 p-0 me-1" style="margin-left: -20px">
        <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.grammarin.com%2F%23%2Fshare%2F{{
            doc_id
          }}&amp;src=sdkpreparse"
          onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=no,scrollbars=no,height=500,width=600');return false;"
          class="fb-xfbml-parse-ignore"><img class="img-fluid" src="/../../assets/images/share/facebook.svg" style="
           height: 86px;
          width: 86px;" /></a>
      </div>
      <div class="col-md-1 col-1 p-0 me-1">
        <a href="https://twitter.com/intent/tweet?text=GrammarIn&url=https%3A%2F%2Fwww.grammarin.com%2F%23%2Fshare%2F{{
            doc_id
          }}&via=#GrammarIn"
          onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=no,scrollbars=no,height=500,width=600');return false;">
          <img class="img-fluid" src="/../../assets/images/share/twitter.svg" alt="twitter-circle" style="
           height: 86px;
            width: 86px;" />
        </a>
      </div>
      <div class="col-md-1 col-1 p-0 me-1">
        <a href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fwww.grammarin.com%2F%23%2Fshare%2F{{
            doc_id
          }}&title=Grammar%20Checker%20X"
          onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=no,scrollbars=no,height=500,width=600');return false;">
          <img class="img-fluid" src="/../../assets/images/share/linkedin.svg" alt="linkedin-circle" style="
          height: 86px;
            width: 86px;" />
        </a>
      </div>
      <div class="col-md-1 col-1 p-0 me-1">
        <a href="https://www.tumblr.com/widgets/share/tool?canonicalUrl=https%3A%2F%2Fwww.grammarin.com%2F%23%2Fshare%2F{{
            doc_id
          }}&posttype=link"
          onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=no,scrollbars=no,height=500,width=600');return false;">
          <img class="img-fluid" src="/../../assets/images/share/timblr.svg" alt="tumbler-circle" style="
           height: 86px;
            width: 86px;" />
        </a>
      </div>
    </div>
    <hr class="mt-4 mx-5">
    <div style="position: relative; text-align: center; margin-top: -30px;">
      <span style="
        background: white;
        padding: 0 10px;
        font-size: 18px;
        font-weight: 500;
        position: relative;
        top: 0px;">OR</span>
    </div>
    <!-- <fieldset class="my-3">
      <legend class="px-3 m-0" align="center">OR</legend>
    </fieldset> -->
    <div style="align-items: center; text-align: center" class="mt-3"> <span class="upload-title"
        style="align-items: center; text-align: center;font-size: 16px; font-weight: 500;">Copy Short Link to
        Clipboard</span>
    </div>
    <div class="input-group my-2 pb-5 ms-lg-5 ms-1" style="    width: 629px;">
      <label for="short_link" class="d-none">s</label>
      <img src="/../../assets/images/share/icon.svg" class="icon " />
      <input type="text" class="form-control me-2" placeholder="https://www.grammarin.com/" #short_link
        aria-label="short_link" value="https://www.grammarin.com/" id="short_link"
        style="    border-radius: 6px; height: 48px;padding-left: 67px; width: 610px;" />
      <button style="  border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;   " type="button" *ngIf="!copylinkture" class="submit my-1"
        (click)="copyToClipboard('short_link')">
        Copy Link
      </button>

      <button style="  border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;" type="button" *ngIf="copylinkture" class=" my-1 copied"
        (click)="copyToClipboard('short_link')">
        Copied
      </button>
    </div>
  </div>
  <!-- <div class="modal-footer">
		<button type="button"
			class="btn btn-outline-dark"
			(click)="modal.close('Save click')">
			Save
		</button>
	</div> -->
</ng-template>

<button class="btn btn-lg btn-outline-primary d-none" (click)="openModels(content)">
  Share
</button>
